<div class="container">
  <!-- Header -->
  <div class="card shadow-sm mb-4">
    <div
      class="card-header bg-primary text-white d-flex justify-content-between align-items-center"
    >
      <h5 class="mb-0">Enterprise Details</h5>

      <div class="d-flex gap-2">
        <!-- Show Approve/Reject only if status = 1 -->
        <ng-container *ngIf="enterpriseDetails?.status === 3">
          <button
            class="btn btn-success btn-sm"
            (click)="approveRejectEnterprise(4)"
          >
            ✔ Approve
          </button>

          <button
            class="btn btn-danger btn-sm"
            (click)="approveRejectEnterprise(5)"
          >
            ✖ Reject
          </button>
        </ng-container>

        <!-- Show Approved if status = 2 -->
        <span
          *ngIf="enterpriseDetails?.status === 4"
          class="badge bg-success fs-6"
        >
          ✔ Approved
        </span>

        <!-- Show Rejected if status = 3 -->
        <span
          *ngIf="enterpriseDetails?.status === 5"
          class="badge bg-danger fs-6"
        >
          ✖ Rejected
        </span>

        <!-- Back button (always show) -->
        <button class="btn btn-light btn-sm" (click)="goBack()">← Back</button>
      </div>
    </div>

    <div class="card-body">
      <!-- Enterprise Basic Info -->
      <div class="row g-3">
        <div class="col-md-6">
          <label class="fw-bold">Enterprise Name:</label>
          <p class="text-muted">
            {{ enterpriseDetails.enterpriseName || "not found" }}
          </p>
        </div>

        <div class="col-md-6">
          <label class="fw-bold">Enterprise Type:</label>
          <p class="text-muted">
            {{ enterpriseDetails.enterpriseType || "not found" }}
          </p>
        </div>

        <div class="col-md-6">
          <label class="fw-bold">Phone:</label>
          <p class="text-muted">{{ enterpriseDetails.phone || "not found" }}</p>
        </div>

        <div class="col-md-6">
          <label class="fw-bold">Email:</label>
          <p class="text-muted">{{ enterpriseDetails.email || "not found" }}</p>
        </div>

        <div class="col-md-6">
          <label class="fw-bold">City:</label>
          <p class="text-muted">{{ enterpriseDetails.city || "not found" }}</p>
        </div>

        <div class="col-md-6">
          <label class="fw-bold">State:</label>
          <p class="text-muted">{{ enterpriseDetails.state || "not found" }}</p>
        </div>

        <div class="col-md-12">
          <label class="fw-bold">Address:</label>
          <p class="text-muted">
            {{ enterpriseDetails.address || "not found" }}
          </p>
        </div>
      </div>

      <hr />

      <!-- User Details -->
      <h6 class="fw-bold text-primary mt-3">User Details</h6>
      <div class="row g-3">
        <div class="col-md-4">
          <label class="fw-bold">First Name:</label>
          <p class="text-muted">
            {{ enterpriseDetails.userDetails.firstName || "not found" }}
          </p>
        </div>

        <div class="col-md-4">
          <label class="fw-bold">Last Name:</label>
          <p class="text-muted">
            {{ enterpriseDetails.userDetails.lastName || "not found" }}
          </p>
        </div>

        <div class="col-md-4">
          <label class="fw-bold">User Email:</label>
          <p class="text-muted">
            {{ enterpriseDetails.userDetails.emailId || "not found" }}
          </p>
        </div>

        <div class="col-md-4">
          <label class="fw-bold">User Phone:</label>
          <p class="text-muted">
            {{ enterpriseDetails.userDetails.phoneNumber || "not found" }}
          </p>
        </div>
      </div>

      <hr />

      <!-- Bank Info -->
      <h6 class="fw-bold text-primary mt-3">Bank Information</h6>
      <div class="row g-3">
        <div class="col-md-6">
          <label class="fw-bold">Bank Name:</label>
          <p class="text-muted">
            {{ enterpriseDetails.bankName || "not found" }}
          </p>
        </div>

        <div class="col-md-6">
          <label class="fw-bold">Account Number:</label>
          <p class="text-muted">
            {{ enterpriseDetails.bankAccountNumber || "not found" }}
          </p>
        </div>

        <div class="col-md-6">
          <label class="fw-bold">IFSC Code:</label>
          <p class="text-muted">
            {{ enterpriseDetails.bankIfscCode || "not found" }}
          </p>
        </div>

        <div class="col-md-6">
          <label class="fw-bold">UPI ID:</label>
          <p class="text-muted">{{ enterpriseDetails.upiId || "not found" }}</p>
        </div>
      </div>

      <hr />

      <!-- Other Info -->
      <h6 class="fw-bold text-primary mt-3">Other Details</h6>
      <div class="row g-3">
        <div class="col-md-4">
          <label class="fw-bold">GST Number:</label>
          <p class="text-muted">
            {{ enterpriseDetails.gstNumber || "not found" }}
          </p>
        </div>

        <div class="col-md-4">
          <label class="fw-bold">PAN Number:</label>
          <p class="text-muted">
            {{ enterpriseDetails.pancardNumber || "not found" }}
          </p>
        </div>

        <div class="col-md-4">
          <label class="fw-bold">Frequency:</label>
          <p class="text-muted">
            {{ enterpriseDetails.frequency || "not found" }}
          </p>
        </div>

        <div class="col-md-4">
          <label class="fw-bold">Trips / Month:</label>
          <p class="text-muted">
            {{ enterpriseDetails.noOfTrips || "not found" }}
          </p>
        </div>

        <div class="col-md-4">
          <label class="fw-bold">Status:</label>
          <span
            class="badge"
            [ngClass]="{
              'bg-success': enterpriseDetails.status === 4,
              'bg-danger': enterpriseDetails.status === 5,
              'bg-warning':
                enterpriseDetails.status === 1 ||
                enterpriseDetails.status === 2 ||
                enterpriseDetails.status === 3
            }"
          >
            {{
              enterpriseDetails.status === 1 || enterpriseDetails.status === 2
                ? "Pending"
                : enterpriseDetails.status === 3
                ? "In Process"
                : enterpriseDetails.status === 4
                ? "Approved"
                : enterpriseDetails.status === 5
                ? "Rejected"
                : "Not Found"
            }}
          </span>
        </div>

        <div class="col-md-4">
          <label class="fw-bold">Created At:</label>
          <p class="text-muted">
            {{ enterpriseDetails.createdAt | date : "medium" }}
          </p>
        </div>
      </div>

      <hr />

      <!-- QR Code -->
      <h6 class="fw-bold text-primary mt-3">QR Code</h6>
      <div class="text-center">
        <img
          [src]="enterpriseDetails.qrCode"
          class="img-fluid rounded border p-2"
          style="max-width: 200px"
          alt="QR Code"
        />
      </div>

      <hr />

      <h6 class="fw-bold text-primary mt-2 mb-2">Uploaded Documents</h6>

      <div
        class="row g-2 mb-0"
        *ngIf="enterpriseDocuments?.length; else noDocs"
      >
        <div class="col-md-4" *ngFor="let doc of enterpriseDocuments">
          <div class="card shadow-sm">
            <div class="card-body text-center p-2">
              <h6 class="fw-bold text-capitalize mb-1">
                {{ doc.documentType | titlecase }}
              </h6>

              <img
                [src]="doc.documentUrl"
                class="img-fluid rounded border"
                style="max-height: 160px; object-fit: contain"
                alt="Document"
              />
            </div>
          </div>
        </div>
      </div>

      <ng-template #noDocs>
        <p class="text-muted mb-0">No documents uploaded</p>
      </ng-template>
    </div>
  </div>
</div>

<hr />
